import React, { useMemo, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import "./TablaCuitVinculadosOperativo.css";

const TablaCuitVinculadosOperativo = ({ datos = [], loading = false, darkMode = false, onEditar, onEliminar }) => {
    const [busqueda, setBusqueda] = useState("");

    const datosFiltrados = useMemo(() => {
        const texto = (busqueda || "").trim().toLowerCase();
        const lista = Array.isArray(datos) ? [...datos] : [];

        if (!texto) {
            return lista.sort((a, b) => a.vinculoId - b.vinculoId);
        }

        return lista
            .filter((item) => `${item.vinculoId} ${item.cuitsTexto || ""}`.toLowerCase().includes(texto))
            .sort((a, b) => a.vinculoId - b.vinculoId);
    }, [datos, busqueda]);

    if (loading) {
        return (
            <div className="crm-cuit-loading">
                <Spinner animation="border" size="sm" className="me-2" />
                Cargando vinculos de CUIT...
            </div>
        );
    }

    return (
        <section className={`crm-cuit-wrap ${darkMode ? "is-dark" : ""}`}>
            <div className="crm-cuit-toolbar">
                <Form.Control
                    type="text"
                    value={busqueda}
                    onChange={(e) => setBusqueda(e.target.value)}
                    placeholder="Buscar por vinculo o CUIT..."
                    className="crm-cuit-search"
                />
            </div>

            <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                    <thead className="table-dark">
                        <tr>
                            <th>Vinculo</th>
                            <th>Cantidad</th>
                            <th>CUIT vinculados</th>
                            <th className="text-center">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {datosFiltrados.length === 0 ? (
                            <tr>
                                <td colSpan={4} className="text-center py-4 text-muted">
                                    No hay vinculos para mostrar.
                                </td>
                            </tr>
                        ) : (
                            datosFiltrados.map((item) => (
                                <tr key={item.vinculoId}>
                                    <td>{item.vinculoId}</td>
                                    <td>{item.cantidadCuits}</td>
                                    <td className="crm-cuit-detalle" title={item.cuitsTexto || ""}>{item.cuitsTexto}</td>
                                    <td>
                                        <div className="crm-cuit-actions-group">
                                            <button
                                                type="button"
                                                className="crm-cuit-action-btn is-edit"
                                                title="Editar vinculo"
                                                onClick={() => onEditar?.(item)}
                                                disabled={!onEditar}
                                            >
                                                <FontAwesomeIcon icon={faPen} />
                                            </button>
                                            <button
                                                type="button"
                                                className="crm-cuit-action-btn is-delete"
                                                title="Eliminar vinculo"
                                                onClick={() => onEliminar?.(item)}
                                                disabled={!onEliminar}
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </section>
    );
};

export default TablaCuitVinculadosOperativo;
